import {
    PHONE_NUMBER_SET,
    PHONE_NUMBER_ERROR,
    PHONE_NUMBER_CLEAR_ERROR,
  } from '../constants/payment/phoneConstants.js';

  import {getAxiosInstance} from '../axios/axiosInstance';
  
  export const setPhoneNumber = (phoneNumber) => (dispatch) => {
    try {
      localStorage.setItem('phoneNumber', phoneNumber);
      
      dispatch({
        type: PHONE_NUMBER_SET,
        payload: phoneNumber,
      });
    } catch (error) {
      console.error('Error in setPhoneNumber action:', error);
    }
  };
  
  export const updatePhoneNumberInDB = (phoneNumber, orderId) => async () => {
    const axiosInstance = getAxiosInstance();
    
    if (!orderId || !phoneNumber) {
      console.warn('Missing orderId or phoneNumber for DB update');
      return;
    }
    
    try {
      const result = await axiosInstance.put(`/orders/${orderId}/phone-number`, {
        phoneNumber,
      });
      console.log('Phone number updated in DB:', result.data);
    } catch (error) {
      console.error('Error updating phone number in DB:', error);
    }
  };
  
  export const setPhoneNumberError = () => ({
    type: PHONE_NUMBER_ERROR,
  });
  
  export const clearPhoneNumberError = () => ({
    type: PHONE_NUMBER_CLEAR_ERROR,
  });